function normalizeSearch(search: string | null | undefined): string {
  if (!search || search === '?') return '';
  return search.startsWith('?') ? search : `?${search}`;
}

export function appendLocationSearch(
  path: string,
  search: string | null | undefined,
): string {
  const normalizedSearch = normalizeSearch(search);
  if (!normalizedSearch) return path;

  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}${normalizedSearch.slice(1)}`;
}

export function buildUnitDetailPath(
  unitId: string,
  search: string | null | undefined,
): string {
  return appendLocationSearch(unitId, search);
}

export function buildUnitListPath(
  propertyId: string | undefined,
  installerView: boolean,
  search: string | null | undefined,
): string {
  const listType = installerView ? 'installer' : 'units';
  return appendLocationSearch(`/properties/${propertyId}/${listType}`, search);
}

export function clearSpecificDevicesFilter(params: URLSearchParams): {
  params: URLSearchParams;
  options: { state: null; replace: true };
} {
  return {
    params: new URLSearchParams(params),
    options: { state: null, replace: true },
  };
}
